/* eslint-disable jsdoc/check-param-names -- Introduced in TP-9489. */
/* eslint-disable jsdoc/check-tag-names -- Introduced in TP-9489. */
/* eslint-disable jsdoc/check-types -- Introduced in TP-9489. */
/* eslint-disable jsdoc/require-param -- Introduced in TP-9489. */
/* eslint-disable jsdoc/require-returns -- Introduced in TP-9489. */
/* eslint-disable jsdoc/require-returns-check -- Introduced in TP-9489. */
/* eslint-disable jsdoc/tag-lines -- Introduced in TP-9489. */

import { zones } from './zones';
// eslint-disable-next-line import/no-cycle -- Introduced in TP-9489.
import { renderBanner, randomBanner, getFormats } from './adDisplay';

const SHOW_FORMAT_SINGULAR = 'Zobrazit formát';
const SHOW_FORMAT_PLURAL = 'Zobrazit formáty';
const HIDE_FORMAT_SINGULAR = 'Schovat formát';
const HIDE_FORMAT_PLURAL = 'Schovat formáty';

/**
 * Generates HTML element for format.
 * @param {Array} format - Format (dimensions).
 * @param {Boolean} placeDivider - True if we want to place divider for format.
 * @return {HTMLElement}
 */
const generateFormatElement = (format, placeDivider = true) => {
	const formatElement = document.createElement('div');

	formatElement.className = 'FormatSwitcher-format';
	formatElement.textContent = `${Number(format[0])}x${Number(format[1])}`;

	if (placeDivider) {
		const divider = document.createElement('div');

		divider.className = 'FormatSwitcher-divider';
		formatElement.appendChild(divider);
	}

	return formatElement;
};

/**
 * Compares two formats (dimensions).
 * @param {Array} format1 - Format1
 * @param {Array} format2 - Format2
 */
const compareFormats = (format1, format2) =>
	format1[0] === format2[0] && format1[1] === format2[1];

/**
 * Returns appropriate button label for show/hide formats
 * @param {String} action 'show'/'hide'
 * @param {Node} rollerElement element containing the formats
 * @returns {String}
 */
const getRollerLabel = (action, rollerElement) => {
	const formats = Array.from(
		rollerElement.querySelectorAll('.FormatSwitcher-format'),
	);

	if (action === 'show') {
		return formats.length > 1 ? SHOW_FORMAT_PLURAL : SHOW_FORMAT_SINGULAR;
	}

	if (action === 'hide') {
		return formats.length > 1 ? HIDE_FORMAT_PLURAL : HIDE_FORMAT_SINGULAR;
	}
};

/**
 * Switchs title and rounds dropdown icon.
 * @param {HTMLElement} roller - Container for title and dropdown icon.
 */
const rollFormatSwitcher = (formatSwitcherElement) => {
	const roller = formatSwitcherElement.querySelector('.FormatSwitcher-roller');
	const title = roller.querySelector('div');
	const dropdown = roller.querySelector('.FormatSwitcher-dropdown');

	dropdown.classList.toggle('FormatSwitcher-dropdown--up');

	if (
		!!~title.innerHTML.indexOf(SHOW_FORMAT_PLURAL) ||
		!!~title.innerHTML.indexOf(SHOW_FORMAT_SINGULAR)
	) {
		title.textContent = getRollerLabel('hide', formatSwitcherElement);
	} else {
		title.textContent = getRollerLabel('show', formatSwitcherElement);
	}
};

/**
 * Generates roller (title) of FormatSwitcher. It is title with dropdown icon.
 * @return {HTMLElement}
 */
const generateRoller = (formats) => {
	const rollerElement = document.createElement('div');
	const titleElement = document.createElement('div');
	const dropdownElement = document.createElement('div');

	const dropdown = `<div><svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path fill="#ffffff" d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path>
                      </svg></div>`;

	rollerElement.className = 'FormatSwitcher-roller';

	dropdownElement.className =
		'FormatSwitcher-dropdown FormatSwitcher-dropdown--up';

	dropdownElement.innerHTML = dropdown;

	titleElement.innerHTML =
		formats.length > 1 ? SHOW_FORMAT_PLURAL : SHOW_FORMAT_SINGULAR;

	rollerElement.appendChild(titleElement);
	rollerElement.appendChild(dropdownElement);

	return rollerElement;
};

/**
 * Generates and renders Format Switcher into ad zone element.
 * @param {HTMLElement} ad - HTML element of container for ad.
 * @param {Array} formats - Array of allowed formats.
 */
const renderFormatSwitcher = (ad, formats) => {
	// Generate html elements
	const formatSwitcherElement = document.createElement('div');
	const formatsElement = document.createElement('div');
	const rollerElement = generateRoller(formats);

	// Get dimensions from ad element
	const adFormat = {
		width: ad.getAttribute('data-format-width'),
		height: ad.getAttribute('data-format-height'),
	};

	// Setup formatSwitcher
	formatSwitcherElement.className = 'FormatSwitcher';
	formatSwitcherElement.style.width = `${adFormat.width - 40}px`;

	formatSwitcherElement.addEventListener('click', () => {
		formatsElement.classList.toggle('FormatSwitcher-formats--hidden');
		rollFormatSwitcher(formatSwitcherElement);
	});

	// Setup and append all formats into container
	formatsElement.className =
		'FormatSwitcher-formats FormatSwitcher-formats--hidden';

	formats.forEach((format, index) => {
		const formatElement = generateFormatElement(
			format,
			index < formats.length - 1,
		);

		formatsElement.appendChild(formatElement);

		if (
			adFormat.width === `${format[0]}` &&
			adFormat.height === `${format[1]}`
		) {
			formatElement.classList.add('FormatSwitcher-format--active');
		}

		// Filter zoneData and render new banner
		formatElement.addEventListener('click', () => {
			const zoneId = ad.dataset.zoneid;
			const zoneData = zones.find((zone) => zone.zoneId === zoneId);

			if (zoneData) {
				const filteredData = zoneData.banners.filter((banner) => {
					if (
						banner.tag === 'banner' &&
						compareFormats(format, banner.dimensions)
					) {
						return banner;
					}
				});

				ad.setAttribute('data-format-width', format[0]);
				ad.setAttribute('data-format-height', format[1]);

				if (filteredData.length > 0) {
					renderBanner(ad, randomBanner(filteredData));
					renderFormatSwitcher(ad, getFormats(zoneData, 'banner'));
				} else {
					renderBanner(ad, randomBanner(filteredData), false);
				}
			}
		});
	});

	// Apend formatSwitcher into ad element
	formatSwitcherElement.appendChild(rollerElement);
	formatSwitcherElement.appendChild(formatsElement);
	ad.appendChild(formatSwitcherElement);
};

export default renderFormatSwitcher;
